module.exports = __webpack_public_path__ + "static/img/14introduce.8b1e76da.jpg";